<template lang="html">

    <div class="contenedor-formulario -recuperar column-center">
        <form @submit.prevent="validate">

            <a class="close" @click="$emit('close')">✕</a>

            <h1 class="title-intro">Recuperar contraseña</h1>

            <div class="contenedor-input">
                <input type="text" class="input-text"
                    v-validate="'required'"
                    v-model="data.email"
                    name="email" :placeholder="$t('formulario.email')+'*'" />
                <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{ errors.first('email') }}</span>
            </div>

            <button  class="btn red with-border" :loading="view.loading">Iniciar sesión</button>


        </form>
    </div>

</template>

<script lang="js">

import VeeValidate from 'vee-validate';
import {mapActions} from 'vuex';

export default {
  name: 'formulario-login',
  data(){
      return{
          data : {
              email : '',
          },
          view : {
            clicked : false,
            loading : false
          }
      }
  },
  methods : {
      ...mapActions(['rememberPassword']),
      validate(){
        this.view.clicked = true;
        this.view.loading = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.rememberPassword(this.data).then(r => {
                if(r){
                    this.$emit('close')
                }
                this.view.loading = false;
            })
          }
        });
      }
  }
}
  
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/view-parts/login/recuperar-pass.vue